import { useTranslation } from '@/i18n/useTranslation';

import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';

export function AppLayout() {
  const { t } = useTranslation();
  return (
    <div className="app-shell">
      <a href="#main-content" className="skip-link">
        {t('Skip to main content')}
      </a>
      <Sidebar />
      <div className="app-main">
        <Topbar />
        <main id="main-content" className="app-content" tabIndex={-1}>
          <ErrorBoundary boundaryName={t('Page')}>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
